import styled from 'styled-components';

import TextInput from 'components/TextInput';
import Card from 'components/common/Card';

export const FiltersCard = styled(Card.Content)`
  padding: 8px;
  margin-bottom: 0.5em;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const InnerContain = styled.div`
  flex: 1;
  max-width: 1600px;
  margin-top: calc(88px + 24px);

  ${(props) => props.theme.media.sm.max`
    width: 100%;
    margin-top: 0px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  `}

  ${(props) => props.theme.media.xl.max`
    max-width: 1366px;
    margin-top: calc(88px + 16px);
  `}

  ${(props) => props.theme.media.sm.min`
    padding-left: 16px;
    padding-right: 16px;
  `}
`;

export const OrderItem = styled.div`
  padding: 16px;
  height: 38px;
  flex: 1;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  background-color: ${(props) => (props.secondary ? '#fcfcfc' : 'transparent')};
  border-radius: 4px;
  will-change: background-color, box-shadow, transform;
  transition: transform 0.1s ease-in;

  ${(props) =>
    props.border &&
    `
    box-shadow: 0px 0px 0px 1px #eaeaea;
  `}

  &:hover {
    background-color: rgba(0, 0, 0, 0.03);
    transform: translateX(2px);
  }
`;

export const StatusChipStyled = styled.div`
  flex: 1;
  display: flex;
  border-radius: 2px;
  max-width: 11em;
  height: 2.6em;
  font-size: 0.75em;
  box-shadow: 0px 0px 0px 1px ${(props) => props.color};

  align-items: center;
  justify-content: center;

  will-change: opacity, transform;
  transition: all 0.2s ease-in-out;

  line-height: 1.2em;
  color: ${(props) => props.color};
  font-family: roboto, sans-serif;
`;

export const StandardChipStyled = styled.div`
  flex: 1;
  font-size: 0.75em;
  height: 2.6em;
  display: flex;
  color: #c5d2d88a;
  border-radius: 24px;
  align-items: center;
  font-family: 'Roboto';
  justify-content: center;
  max-width: 11em;
  box-shadow: 0px 0px 0px 1px #c5d2d88a;
`;

export const UrgentChipStyled = styled(StandardChipStyled)`
  box-shadow: 0px 0px 0px 1px ${(props) => props.theme.dangerColor};
  color: ${(props) => props.theme.dangerColor};
`;

export const AddressText = styled.p`
  font-weight: 400;
  font-size: 1em;
  font-family: Roboto;
  color: rgb(45, 68, 83);
  margin: 0px;
`;

export const CreatedText = styled.p`
  font-weight: 300;
  font-size: 16px;
  font-family: Roboto;
  color: rgb(0, 118, 190);
`;

export const NameText = styled(CreatedText)`
  color: rgb(12, 94, 147);
`;

export const FlexItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.justify || 'center'};
  flex: ${(props) => props.flex || 1};
  ${(props) => props.maxWidth && `max-width: ${props.maxWidth}px`}

  ${props => props.paddingLeft && `
    padding-left: ${props.paddingLeft}px;
  `}
`;

export const HeaderText = styled.p`
  flex: 1;
  font-weight: 400;
  font-size: 1em;
  font-family: Roboto;
  color: ${(props) => props.theme.brandColor};
`;

export const FiltersContain = styled.div`
  display: flex;
`;

export const FiltersContainer = styled.div`
  margin-bottom: 0.5em;
`;

export const HeadersContain = styled.div`
  display: flex;
  padding: 0px 16px;
  box-shadow: 0px 1px 0px 0px #0078c014;
`;

export const FilterText = styled.p`
  font-family: 'Roboto';
  font-size: 1em;
  color: grey;
`;

export const FilterInkBar = styled.div`
  height: 2px;
  position: relative;
  width: ${(props) => 100 / props.count}%;
  transition: transform 0.3s ease-out;
  background-color: ${(props) => props.theme.secondaryColor};
  transform: translateX(${(props) => props.selected * 100}%);
`;

export const ButtonBase = styled.div`
  flex: 1;
  display: flex;
  cursor: pointer;
  font-weight: 300;
  justify-content: center;
  will-change: font-weight;
  transition: transform 0.3s ease-out;

  &:hover {
    transform: scale(1.045, 1.045);
    font-weight: 500 !important;
  }
`;

export const SearchInput = styled(TextInput)`
  flex: 1;
  margin: 1px;
  position: relative;
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
`;

SearchInput.defaultProps = {
  placeholder: 'Search Orders by...'
};

export const SearchTitle = styled.div`
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 1em;
  margin-right: 0.5em;
`;

export const SearchContain = styled.div`
  flex: 1;
  display: flex;
  max-width: 840px;
  margin-left: auto;
  padding-right: 8px;
  align-items: center;
  justify-content: space-between;
`;

export const PageButton = styled.button`
  cursor: pointer;
  padding: 8px 12px;
  border-width: 1px;
  border-radius: 4px;
  border-style: none;
  background-color: #fff;
  font-family: 'Roboto';
  margin-right: 0.2em;
  ${(props) =>
    props.isSelected &&
    `color: #fff;
    background-color: ${props.theme.brandColor} !important;
  `}

  box-shadow: 0px 1px 3px 0px rgba(224, 224, 224, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(217, 217, 217, 0.12);
`;

export const PaginationContain = styled.div`
  display: flex;
  padding: 1em;
  padding-bottom: 0.5em;
  align-items: center;
  border-style: solid;
  border-color: #e9e9e9;
  justify-content: space-between;
  border-width: 1px 0px 0px 0px;
`;

export const PageText = styled.p`
  font-family: 'Roboto';
  margin: 0px;
  font-size: 0.875em;
`;

export const OrdersContainer = styled.div`
  margin-bottom: 60px;
`;

export const EmptyMessage = styled.div`
  padding: 1em;
  text-align: center;
  font-family: Roboto;
  font-size: 1em;
  font-weight: 400;
  color: #a0a0a0;
`;

export const Button = styled.div`
  display: flex;
  color: #fff;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  align-items: center;
  padding: 0.75em 1em;
  justify-content: center;
  font-family: 'Roboto';
  background-color: ${(props) => props.theme.brandColor};

  ${(props) =>
    props.disabled &&
    `
    color: #a4a4a4;
    background-color: #e5e5e5;
  `}

  ${(props) =>
    props.secondary &&
    `
    background-color: #fff;
    color: rgb(20, 76, 110);
    box-shadow: inset 0px 0px 0px 2px rgb(20, 76, 110);
  `}

  transition: all 0.15s ease-in-out;

  &:hover {
    opacity: 0.8 !important;
  }

  &:active {
    opacity: 0.5 !important;
  }
`;

export const FlexContain = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonLabel = styled.span`
  margin-left: 0.5em;
`;

export const Text = styled.div`
  font-family: Roboto;
  margin-left: 0.5em;
  font-weight: 400;
  font-size: 0.875em;
  padding: 0.5em 0.5em;
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StatusFilterContain = styled.div`
  flex: 1;
`;

export const CouncilText = styled(AddressText)`
  font-weight: 300;
  color: rgb(12, 94, 147);
`;

export const FileText = styled(AddressText)`
  color: rgb(12,94,147);
`;

export const TextContain = styled.div`
  
`;

export const SecondaryText = styled.p`
  font-family: 'Roboto';
  background-color: #6a7a8517;
  padding: 0.4em 0.6em;
  border-radius: 2px;
  color: #495e6a;
  margin: 0px;
  font-size: 0.8em;
  display: inline-block;
  margin-top: 4px;
`;
